import React, { useContext, useEffect } from "react";
import { Gamepad2, Star, Trophy } from "lucide-react";
import { Link } from "react-router-dom";
import { DataContext } from "../../Context/DataContext";

const FeaturedSection = () => {
  const gameData = useContext(DataContext);

useEffect(() => {
  const loadAOS = async () => {
    const AOS = await import('aos');
    AOS.init({
      duration: 500,
      easing: "ease-out-cubic",
      once: true,
      offset: 100
    });
  };
  loadAOS();
}, []);

const createSlug = (text) => {
    return text
      ?.toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/[\s_-]+/g, '-')
      .replace(/^-+|-+$/g, '');
};


  return (
    <section className="bg-gradient-to-b lg:px-8 from-[#0a0f1f] to-[#141a2e] sm:py-16 py-10 ">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12" data-aos="fade-up" data-aos-delay="100"
        >
          <h2 className="text-2xl sm:text-3xl md:text-4xl xl:text-5xl font-bold text-white">
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 via-blue-400 to-purple-300">
              🔥 Trending & Popular
            </span>{" "}
            Games
          </h2>
          <div className="flex justify-center">
            <p className="text-gray-400 sm:text-lg text-[16px] mt-4 md:w-3/4 leading-relaxed">
              Explore our hand-picked collection of <strong>most popular free online games</strong>. 
              These top-rated titles are loved by millions of players worldwide. 
              From intense <strong>action battles</strong> to relaxing <strong>puzzles</strong>, 
              play these viral hits instantly on your mobile or desktop <strong>without downloading</strong>.
            </p>
          </div>
        </div>

        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3  mx-auto">
          {gameData?.slice(6, 9)?.map((game, index) => {

            const gameSlug = createSlug(game?.name);

            return(
              <div
              key={index}
              data-aos="zoom-in"
              data-aos-delay={`${300 + index * 100}`}
              className="relative bg-[#1b2236] rounded-2xl cursor-pointer overflow-hidden transition-all duration-500 group shadow-[0_0_20px_rgba(0,0,0,0.3)] hover:shadow-[0_0_35px_rgba(0,150,255,0.5)]hover:scale-105 hover:-translate-y-2"
            >
              <Link to={`/play/${gameSlug}`} state={{ game: game }} aria-label={`Play ${game?.name} free online`}>
                <div className="relative overflow-hidden">
                  <picture>
                    <source srcSet={game?.image} type="image/webp" />
                    <img
                      src={game?.image}
                      alt={`Play ${game?.name} free online at Game Zone`}
                      className="w-full h-52 object-cover transform transition-transform duration-700   group-hover:scale-110"
                      loading="lazy"
                      decoding="async"
                      />
                  </picture>
                  <div className="absolute inset-0 bg-gradient-to-t from-transparent via-transparent   to-white/15 opacity-0 group-hover:opacity-100 transition-opacity duration-700"></div>
                  <div className="absolute top-3 right-3 bg-yellow-500/90 text-black text-xs font-bold px-2 py-1 rounded flex items-center gap-1 shadow-lg">
                        <Star size={12} fill="black" /> Top Rated
                    </div>
                </div>
              </Link>

              <div className="p-5 relative z-10">
                <h3
                  className="sm:text-xl text-lg font-semibold text-white"
                  data-aos="fade-up"
                  data-aos-delay={`${400 + index * 150}`}
                >
                  {game?.name}
                </h3>
                <p
                    className="text-gray-400 text-sm mt-2 line-clamp-2 min-h-[40px]"
                    data-aos="fade-up"
                    data-aos-delay={`${450 + index * 150}`}
                  >
                    {game?.desc || `Play ${game?.name} for free online. Enjoy one of the best browser games with no download required.`}
                </p>

                <Link to={`/play/${gameSlug}`} state={{ game: game }}>
                  <button
                    data-aos="flip-left"
                    data-aos-delay={`${500 + index * 150}`}
                    className="mt-4 px-4 py-2 bg-gradient-to-r from-cyan-400 via-blue-400 to-purple-300
                               text-black font-[600] text-sm rounded-lg flex items-center gap-2 
                               transition-all duration-300 shadow-md hover:shadow-[0_0_15px_rgba(0,150,255,0.5)]"
                  >
                    <Gamepad2 size={18} /> Play Online Free 
                  </button>
                </Link>
              </div>

              <div className="absolute inset-0 rounded-2xl border border-transparent group-hover:border-cyan-400/50 transition-all duration-500 blur-[0.5px]"></div>

              <div className="absolute -z-10 bottom-0 right-0 w-32 h-32 bg-cyan-500/30 rounded-full mix-blend-overlay blur-3xl group-hover:scale-125 transition-transform duration-700"></div>
            </div>
            )
          })}
        </div>
        <div className="mt-16 text-center max-w-4xl mx-auto border-t border-white/10 pt-8" data-aos="fade-up">
            <div className="flex items-center justify-center gap-2 mb-4 text-yellow-400">
                <Trophy size={20} /> <span className="text-sm font-bold tracking-widest uppercase">Editor's Choice</span>
            </div>
            <p className="text-gray-400 text-sm">
                Our <strong>Featured Games</strong> section highlights the most played and highest-rated titles on Game Zone. 
                Whether you are looking for <strong>single-player adventures</strong>, 
                these picks are guaranteed to provide hours of entertainment. All games are optimized for fast loading and smooth performance on Chrome, Safari, and Edge.
            </p>
        </div>
      </div>
    </section>
  );
};

export default FeaturedSection;
